(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["knot-membership-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    function enhanceMembership(root) {
      root.querySelectorAll('.kn-membership').forEach(dialog => {
        if (dialog.dataset.focusReady) return;
        dialog.dataset.focusReady = 'true';
        let previousFocus = null;
        let wasOpen = false;
        const update = () => {
          const open = dialog.classList.contains('open');
          dialog.inert = !open;
          dialog.setAttribute('aria-hidden', String(!open));
          if (open && !wasOpen) {
            previousFocus = document.activeElement;
            dialog.scrollTop = 0;
            dialog.querySelector('.kn-close').focus({ preventScroll: true });
          } else if (!open && wasOpen && previousFocus?.isConnected) {
            previousFocus.focus({ preventScroll: true });
          }
          wasOpen = open;
        };
        new MutationObserver(update).observe(dialog, { attributes: true, attributeFilter: ['class'] });
        dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const links = Array.from(dialog.querySelectorAll('button, a[href]')).filter(el => el.getClientRects().length);
          const first = links[0], last = links[links.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        });
        update();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhanceMembership(document));
    else enhanceMembership(document);
    document.addEventListener('shopify:section:load', event => enhanceMembership(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
